import React, { useState } from 'react';
import "./skills.css"
import Frontend from './frontend';
import Backend from './backend';
import Software from './Software';
import DataEn from './dataEn';
import AI from './AI';
import AiTechniques from './AiTechniques';
import DB from './Database';
import Prod from './Prod';
import Other from './Other';
const Skills = () =>{
    const [showAll, setShowAll] = useState(false);

    const initialSkills = [
        <Frontend key="frontend"/>,
        <Backend key="backend"/>,
        <Software key="software"/>
    ];

    const additionalSkills = [
        <DataEn key="dataen"/>,
        <AI key="ai"/>,
        <AiTechniques key="aitechniques"/>,
        <DB key="db"/>,
        <Prod key="prod"/>,
        <Other key="other"/>
    ];

    return(
        <section className="skills section" id="skills">
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">My technichal level</span>

            <div className="skills__container container grid">
                {initialSkills}
                
                {showAll && additionalSkills}
            </div>
            
            <div className="skills__toggle">
                <button 
                    className="button button--small skills__button"
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? 'Show Less' : 'Show More'}
                </button>
            </div>
        </section>
    )
}


export default Skills